module.exports = __webpack_public_path__ + "img/GH-kyujin-top-021.c5b54be9.webp";